export default __webpack_public_path__ + "static/media/D_content5.ebc9e86d.png";